import RawMaterialHeader from "./Header";
import "./index.css";
import ProdComponentContents from "./ProdComponentContents";
import ProductSpecificPackaging from "./ProductSpecificPackaging";
import ProductTransportWrappingContents from "./ProductTransportWrapping";
import ProdWaterUsageContents from "./ProdWaterUsage";
import ProdSurplusTransportContents from "./ProdSurplusTransport";
import ProdLossesContents from "./ProdLosses";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const RawMaterialComponents = ({
  productId,
  showCategory,
  setShowCategory,
}) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const handleShowCategory = () => {
    setShowCategory(!showCategory);
  };

  return (
    <div className="raw-material-container" id="raw-material-id">
      <RawMaterialHeader
        productId={productId}
        show={show}
        // handleShowCategory={handleShowCategory}
        // isCategory={true}
        // showCategory={showCategory}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && <ProdComponentContents productId={productId} />}
      {show && <ProductSpecificPackaging productId={productId} />}
      {show && <ProductTransportWrappingContents productId={productId} />}
      {show && <ProdWaterUsageContents productId={productId} />}
      {show && <ProdSurplusTransportContents productId={productId} />}
      {show && <ProdLossesContents productId={productId} />}
    </div>
  );
};

export default RawMaterialComponents;
